import React, { useEffect, useState, useMemo } from 'react';
import { Tab, Tabs } from '../UI/Tabs';
import InjuryTable from '../UI/InjuryTable';

//firebase
import { ref, get, child } from "firebase/database"; // Import Firebase database functions
import { getAuth, signInAnonymously } from "firebase/auth";
import { db } from "../utils/firebase" // Adjust the path to your Firebase config


const AvailableInjuries = () => {
  const [injuries, setInjuries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [httpError, setHttpError] = useState();

  const columns = useMemo(() => [
    {
      Header: 'Player Info',
      columns: [
        {
          Header: 'First Name',
          accessor: 'firstName',
        },
        {
          Header: 'Last Name',
          accessor: 'lastName',
        },
      ],
    },
    {
      Header: 'Injury Details',
      columns: [
        {
          Header: 'Reason',
          accessor: 'reason',
        },
        {
          Header: 'Return Date',
          accessor: 'returnDate',
        },
        {
          Header: 'Condition',
          accessor: 'condition',
        },
        {
          Header: 'Status',
          accessor: 'status',
        },
      ],
    },
  ], []);

  useEffect(() => {
    setIsLoading(true);

   // const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    const CACHE_DURATION = 0; // 24 hours in milliseconds
    const cachedInjuries = localStorage.getItem('cachedInjuries');
    const cacheTime = localStorage.getItem('cacheTime');

    const isCacheValid = cacheTime && (new Date().getTime() - new Date(parseInt(cacheTime)).getTime()) < CACHE_DURATION;

    if (cachedInjuries && isCacheValid) {
      setInjuries(JSON.parse(cachedInjuries));
      setIsLoading(false);
      return; // If cached data is available and valid, use it and skip fetching
    }


    const fetchInjuries = async () => {
      try {
        const dbRef = ref(db);
        const snapshot = await get(child(dbRef, `drupal-data/sport/en/injuries`)); // Adjust the path as needed

        if (!snapshot.exists()) {
          throw new Error("No data available");
        }
        
        const response = await snapshot.val();

        const responseText = await response.xml; 

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(responseText, "text/xml");

        // Get all teams
        const teams = xmlDoc.querySelectorAll("Team");

        // Construct an array from the teams
        const injuriesArray = Array.from(teams).map((team, teamIndex) => {
          const teamName = team.getElementsByTagName("Name")[0].textContent;
          const allInjuries = team.querySelectorAll("Injury");

          // Map over injuries and construct an array of injury objects
          const injuryArray = Array.from(allInjuries).map((injury, injuryIndex) => {
            return {
              firstName: injury.getElementsByTagName("PlayerFirstName")[0].textContent,
              lastName: injury.getElementsByTagName("PlayerLastName")[0].textContent,
              reason: injury.getElementsByTagName("Reason")[0].textContent,
              returnDate: injury.getElementsByTagName("Return")[0].textContent,
              condition: injury.getElementsByTagName("Condition")[0].textContent,
              status: injury.getElementsByTagName("Status")[0].textContent,
              key: injuryIndex,
            };
          });

          return {
            teamName: teamName,
            injuries: injuryArray,
            key: teamIndex,
          };
        });

        localStorage.setItem('cachedInjuries', JSON.stringify(injuriesArray)); // Cache the data
        localStorage.setItem('cacheTime', new Date().getTime().toString()); // Cache the time of caching
        setInjuries(injuriesArray);
      } catch (error) {
        setHttpError(error.message);
      } finally {
        setIsLoading(false);
      }
    };


    const auth = getAuth();
    signInAnonymously(auth)
      .then(() => {
        // User is signed in anonymously, proceed to fetch data
        fetchInjuries();
      })
      .catch((error) => {
        setHttpError(error.message);
        setIsLoading(false);
      });
      
  }, []);

  if (isLoading) {
    return (
      <section className="LoadingSection">
        <p>Loading...</p>
      </section>
    );
  }

  if (httpError) {
    return (
      <section className="ErrorSection">
        <p>{httpError}</p>
      </section>
    );
  }

  const injuriesList = injuries.map((teamItem) => (
    <Tab key={teamItem.key} id={`team-${teamItem.key}`} label={teamItem.teamName}>
      <InjuryTable columns={columns} data={teamItem.injuries} />
    </Tab>
  ));

  return (
    <section className="Injuries">
      <Tabs>{injuriesList}</Tabs>
      {isLoading && <p>Loading more...</p>}
    </section>
  );
};

export default AvailableInjuries;
